import React, { useState, useEffect, useCallback, useRef } from "react";
import useAppContext from "../../../utils/Reducers";
import ButtonBar from "../../../components/Layout/ButtonBar";
import SearchBar from "./SearchBar";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { ModalConfirm } from "../../../components/Confirm";
import { columnLayout } from "./columnLayout";
import { defaultGridProps } from "../../../components/AuiGrid/gridLayout";
import {
  setStorageItem,
  getStorageItem,
} from "../../../hooks/Storage/useLocalStorage";
import moment from "moment";
import AUIGrid from "../../../lib/AuiGrid/AUIGridReact";
import { saveGridCheckData } from "../../../utils/validators";

//전송버튼을 클릭했을경우 함수가 외부에서 호출하여 primaryParameters 아무값도 들어가 있지 않음
//그래서 플래그를 두어 sendCnt값이 변경되면 useEffect에서 검색버튼의 함수를 실행시킴
var sendCnt = 0;

let initValue = {
  realWeight: "",
  heavyWeight: "",
  lightWeight: "",
  turningWeight: "",
  distWeight: "",
  restWeight: "",
};

let gridValue = {
  heavyScrap: "",
  lightScrap: "",
  turningScrap: "",
};

const MagnetMng = (props) => {
  var footerLayout = [
    {
      labelText: "합계",
      positionField: "#base",
    },
    {
      dataField: "plantNm",
      positionField: "plantNm",
      operation: "COUNT",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },

    {
      dataField: "heavyScrap",
      positionField: "heavyScrap",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "lightScrap",
      positionField: "lightScrap",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "turningScrap",
      positionField: "turningScrap",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
  ];

  const myGrid = useRef();
  const [research, setResearch] = useState(0);

  const {
    store: { userInfo, menuKey },
  } = useAppContext();

  useEffect(() => {
    const auiGrid = myGrid.current;
    auiGrid.resize("100%", 600);
  }, [menuKey]);
  //console.log(userInfo);
  const [searchParameters, setSearchParameters] = useState({
    schPlantCd:
      userInfo.defaultPlantNo !== null ? userInfo.defaultPlantNo : "GP",
    schMonth: moment().format("YYYY-MM"),
  });

  const initItem = {
    realWeight: "0",
    heavyWeight: "0",
    lightWeight: "0",
    turningWeight: "0",
    distWeight: "0",
    restWeight: "0",
  };

  const gridItem = {
    heavyScrap: "0",
    lightScrap: "0",
    turningScrap: "0",
  };

  const restItem = {
    heavyRest: "0",
    lightRest: "0",
    turningRest: "0",
  };

  const [fieldValues, setFieldValues] = useState(initItem);
  const [gridValues, setGridValues] = useState(gridItem);
  const [restValues, setRestValues] = useState(restItem);

  const SEARCH_MAGNETTOTAL_URL = "/rawmaterial/searchMagnetTotal.do";

  const SEARCH_MAGNETLIST_URL = "/rawmaterial/searchMagnetList.do";

  const SAVE_MAGNET_URL = "/rawmaterial/saveMagnet.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SEARCH_MAGNETLIST_URL,
    },
    { manual: true }
  );

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    if (research !== 0) {
      handleMasterSearch();
    }
  }, [research]);

  useEffect(() => {
    const auiGrid = myGrid.current;
    auiGrid.setFooter(footerLayout);

    auiGrid.bind("cellEditEnd", auiCellEditingHandler);

    //Local Storage에 저장된 그리드 컬럼 정렬정보를 가져옴
    const columnList = getStorageItem(props.menuInfo.menuId, "");
    if (columnList !== "") {
      auiGrid.setColumnOrder(columnList);
    }
    const columnSize = getStorageItem(props.menuInfo.menuId + "_s", "");
    if (columnSize !== "") {
      //Local Storage에 저장된 그리드 컬럼 Width 정보를 가져옴
      auiGrid.setColumnSizeList(columnSize);
    }
  }, []);

  const auiCellEditingHandler = useCallback(async (event) => {
    //console.log(event.value);

    const auiGrid = myGrid.current;
    //console.log(event);
    var heavy = auiGrid.getFooterValueByDataField(event.dataField);
    //console.log(fieldValues);
    setGridValues({
      heavyScrap: auiGrid.getFooterValueByDataField("heavyScrap"),
      lightScrap: auiGrid.getFooterValueByDataField("lightScrap"),
      turningScrap: auiGrid.getFooterValueByDataField("turningScrap"),
    });
    gridValue = {
      heavyScrap: auiGrid.getFooterValueByDataField("heavyScrap"),
      lightScrap: auiGrid.getFooterValueByDataField("lightScrap"),
      turningScrap: auiGrid.getFooterValueByDataField("turningScrap"),
    };
    if (event.dataField === "heavyScrap") {
      //console.log(parseInt(initValue.heavyWeight.replaceAll(",", "")));
      //console.log(parseInt(heavy) + parseInt(event.value));
      if (
        parseInt(initValue.heavyWeight.replaceAll(",", "")) < parseInt(heavy)
      ) {
        await ModalConfirm({
          title: "오류",
          description: "중량 입고량을 초과하였습니다. ",
          type: "alert",
        });
        return event.oldValue;
      }
    } else if (event.dataField === "lightScrap") {
      if (
        parseInt(initValue.lightWeight.replaceAll(",", "")) < parseInt(heavy)
      ) {
        await ModalConfirm({
          title: "오류",
          description: "경량 입고량을 초과하였습니다. ",
          type: "alert",
        });
        return event.oldValue;
      }
    } else if (event.dataField === "turningScrap") {
      if (
        parseInt(initValue.turningWeight.replaceAll(",", "")) < parseInt(heavy)
      ) {
        await ModalConfirm({
          title: "오류",
          description: "선반 입고량을 초과하였습니다. ",
          type: "alert",
        });
        return event.oldValue;
      }
    }
    return event.value;
  });

  const handleMasterExcel = useCallback(() => {
    const auiGrid = myGrid.current;
    auiGrid.exportToXlsx({
      fileName: props.menuInfo.menuNmKor + " 리스트",
      exceptColumnFields: auiGrid.getHiddenColumnDataFields(),
    });
  });

  const handleMasterSearch = async () => {
    //console.log(fieldValues);
    const auiGrid = myGrid.current;
    auiGrid.showAjaxLoader();
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_MAGNETLIST_URL,
      params: searchParameters,
    });
    auiGrid.setGridData(data);

    const response = await fetchData({
      url: SEARCH_MAGNETTOTAL_URL,
      params: searchParameters,
    });
    const count = response.data.data[0];
    //console.log(response.data.data[0]);
    setFieldValues({
      realWeight: count.realWeight,
      distWeight: count.distWeight,
      restWeight: count.restWeight,
      heavyWeight: count.heavyWeight,
      lightWeight: count.lightWeight,
      turningWeight: count.turningWeight,
    });
    setGridValues({
      heavyScrap: auiGrid.getFooterValueByDataField("heavyScrap"),
      lightScrap: auiGrid.getFooterValueByDataField("lightScrap"),
      turningScrap: auiGrid.getFooterValueByDataField("turningScrap"),
    });

    initValue = {
      realWeight: count.realWeight,
      distWeight: count.distWeight,
      restWeight: count.restWeight,
      heavyWeight: count.heavyWeight,
      lightWeight: count.lightWeight,
      turningWeight: count.turningWeight,
    };
    gridValue = {
      heavyScrap: auiGrid.getFooterValueByDataField("heavyScrap"),
      lightScrap: auiGrid.getFooterValueByDataField("lightScrap"),
      turningScrap: auiGrid.getFooterValueByDataField("turningScrap"),
    };

    auiGrid.removeAjaxLoader();
  };

  //그리드 정렬 취소
  const handleMasterSave = useCallback(async () => {
    if (
      await ModalConfirm({
        title: "저장",
        description: "데이터를 저장하시겠습니까?",
      })
    ) {
      const auiGrid = myGrid.current;

      const addItems = auiGrid.getAddedRowItems();
      const editItems = auiGrid.getEditedRowItems();
      const removeItems = auiGrid.getRemovedItems();

      let param = saveGridCheckData(addItems, editItems, removeItems);

      const {
        data: { data },
      } = await fetchData({
        url: SAVE_MAGNET_URL,
        data: param,
        method: "POST",
      });

      handleMasterSearch();
    }
  });

  const headStyle = {
    width: "130px",
    textAlign: "right",
    border: "1px solid #c5c5c5",
  };
  const valueStyle = {
    width: "200px",
    textAlign: "right",
    border: "1px solid #c5c5c5",
  };
  return (
    <>
      <ButtonBar
        menuInfo={props.menuInfo}
        handleMasterSearch={handleMasterSearch}
        handleMasterSave={handleMasterSave}
        handleMasterExcel={handleMasterExcel}
      />
      <SearchBar
        setSearchParameters={setSearchParameters}
        searchParameters={searchParameters}
      />

      <table className="t_garo" style={{ border: "1px solid #c5c5c5" }}>
        <tr>
          <td style={headStyle}>중량 총량</td>
          <td style={valueStyle}>
            {" "}
            {fieldValues.heavyWeight
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            kg
          </td>
          <td style={headStyle}>경량 총량</td>
          <td style={valueStyle}>
            {" "}
            {fieldValues.lightWeight
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            kg
          </td>
          <td style={headStyle}>선반 총량</td>
          <td style={valueStyle}>
            {" "}
            {fieldValues.turningWeight
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            kg
          </td>
          <td style={headStyle}>마그네트 총량</td>
          <td style={valueStyle}>
            {" "}
            {fieldValues.realWeight
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            kg
          </td>
          <td style={headStyle} rowSpan={2}>
            분배 가능 잔량(DB)
          </td>
          <td
            style={{
              width: "200px",
              textAlign: "right",
            }}
            rowSpan={2}
          >
            <font color={parseInt(fieldValues.restWeight) < 0 ? "red" : ""}>
              {fieldValues.restWeight}kg
            </font>
          </td>
          <td rowSpan={2} style={{ widtd: "30%" }}></td>
        </tr>
        <tr>
          <td style={headStyle}>중량 분배량</td>
          <td style={valueStyle}>
            {gridValues.heavyScrap
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            kg
          </td>
          <td style={headStyle}>경량 분배량</td>
          <td style={valueStyle}>
            {gridValues.lightScrap
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            kg
          </td>
          <td style={headStyle}>선반 분배량</td>
          <td style={valueStyle}>
            {gridValues.turningScrap
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            kg
          </td>
          <td style={headStyle}>현재 분배 총량(DB)</td>
          <td style={valueStyle}> {fieldValues.distWeight}kg</td>
        </tr>
        <tr>
          <td style={headStyle}>중량 잔량</td>
          <td
            style={{
              ...valueStyle,
              color:
                parseInt(fieldValues.heavyWeight) -
                  parseInt(gridValues.heavyScrap) <
                0
                  ? "red"
                  : "",
            }}
          >
            {(
              parseInt(fieldValues.heavyWeight) -
              parseInt(gridValues.heavyScrap)
            )
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            kg
          </td>
          <td style={headStyle}>경량 잔량</td>
          <td
            style={{
              ...valueStyle,
              color:
                parseInt(fieldValues.lightWeight) -
                  parseInt(gridValues.lightScrap) <
                0
                  ? "red"
                  : "",
            }}
          >
            {(
              parseInt(fieldValues.lightWeight) -
              parseInt(gridValues.lightScrap)
            )
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            kg
          </td>
          <td style={headStyle}>선반 잔량</td>
          <td
            style={{
              ...valueStyle,
              color:
                parseInt(fieldValues.turningWeight) -
                  parseInt(gridValues.turningScrap) <
                0
                  ? "red"
                  : "",
            }}
          >
            {(
              parseInt(fieldValues.turningWeight) -
              parseInt(gridValues.turningScrap)
            )
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            kg
          </td>
        </tr>
      </table>
      <AUIGrid
        ref={myGrid}
        columnLayout={columnLayout()}
        gridProps={{
          ...defaultGridProps,
          width: "100%",
          height: 600,
          editable: true,
          // 푸터 사용 여부
          showFooter: true,
          footerPosition: "top",
        }}
      />
    </>
  );
};

export default MagnetMng;
